import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, Observable } from 'rxjs';
import { ShService } from './sh-service';
import { ApiDataService } from './api.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  token: string = '';
  refreshToken: string = '';
  isExpired: boolean = false;
  retryUnAuthorizedRequestCount: number = 0;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private _service: ShService,
    private _apiService: ApiDataService
  ){
    this.token = sessionStorage.getItem('token') || '';
    this.refreshToken = sessionStorage.getItem('refresh-token') || '';
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        'Content-Type' : 'application/json; charset=utf-8',
        'Accept'       : 'application/json',
        'Authorization' : `Bearer ${this.isExpired? sessionStorage.getItem('refresh-token') : sessionStorage.getItem('token')}` || ''
      },
      body: {...req.body, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone}
    });

    return next.handle(req).pipe(
      catchError(err => 
        new Observable<HttpEvent<any>>(observer => {
          if (err instanceof HttpErrorResponse) {
            const errResp = <HttpErrorResponse>err;
            if (errResp.status === 401) {
              this.isExpired = true;
              this.retryUnAuthorizedRequestCount++;
              if(this.retryUnAuthorizedRequestCount > 3){
                this.toastr.error('Session Expired. Please login again.', 'FAILED', {
                  timeOut: 3000,
                });
                sessionStorage.clear();
                this.router.navigate(["/"]);
                return observer.complete();
              }

              return this.handle401();
              // this.toastr.error('Unauthorized Access', 'FAILED', {
              //   timeOut: 3000,
              // });
              // setTimeout(() => {
              //   sessionStorage.clear();
              //   this.router.navigate(["/"]);
              // }, 1000);
            }
            else {
              this.isExpired = false;
              if(errResp.status === 200){

              }
              else{
                this.toastr.error(`${errResp.message}`, 'FAILED', {
                  timeOut: 3000,
                });
              }
            }
          }
          observer.error(err);
          observer.complete();
        })
      ),
      finalize(() => {
        this._service.init.next(null);
      })
    );
  };

  handle401(){
    const PAYLOAD = {
      token: sessionStorage.getItem('refresh-token') || ''
    }
    this._apiService.refreshToken(PAYLOAD).subscribe((x) => {
      sessionStorage.setItem('token', x.newAccessToken);
      window.location.reload();
    }, (error) => {
    });
  }
}